import { useEffect } from 'react';

function Anmalan() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="anmalan-section">
      <div className="container">
        <div className="anmalan-content">
          <div className="anmalan-header">
            <i className="fas fa-calendar-check anmalan-icon"></i>
            <h1>Anmälan</h1>
            <p className="anmalan-subtitle">Anmäl dig till vårt nästa event</p>
          </div>

          <div className="anmalan-button-container">
            <h2>Anmäl dig här</h2>
            <p>Klicka på knappen nedan för att fylla i anmälningsformuläret</p>
            <a
              href="https://docs.google.com/forms/d/1TscTiCRuDoHrqqBURHw3Zkl1NglrUAmbBltXd7p79Gg/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-anmalan"
            >
              <i className="fas fa-edit"></i>
              Anmäl dig nu
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Anmalan;
